import { API_URL } from "../config"
import { getToken } from "../util/validation";

const token = JSON.parse(getToken);
export async function getGoDaddyData(){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_godaddy_data/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function get_jnr_domain_data() {
  try {
    const email = localStorage.getItem("user");
    const loginToken = localStorage.getItem("login_token");

    const response = await fetch(
      API_URL+"/adminpanel/get_jnr_domain_data/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${loginToken}`, 
        },
        body: JSON.stringify({ email }),
      }
    );

    console.log("API status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API error:", errorText);
      return false;
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error("Network error:", error);
    return false;
  }
}

export async function sendJNRNotification(requestBody){

    try {
        // console.log(parseInt(subscription_id))
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'requestBody': requestBody,
        }

        const response = await fetch(API_URL + 'adminpanel/sendJnrNotification/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}
